import { navItemType } from '@cx-web/domain-types';

import { useLayoutStore } from '~/providers/layout-store-provider';

import ScrollableRow from '../ScrollableRow';
import WrappedIcon from '../WrappedIcon';

import styles from './FeaturedMenu.module.css';

export const FeaturedMenu = () => {
  const featuredLinks = useLayoutStore(
    s =>
      s.navData.mobileBottomNav.find(item => item.type === navItemType.ALL_SPORTS_EXPANDABLE)?.items?.featuredLinks ||
      [],
  );

  return (
    <ScrollableRow className={styles.featuredMenu}>
      {featuredLinks.map(item => (
        <a className={styles.featuredItem} href={item.link} key={item.name}>
          <WrappedIcon className={styles.featuredIcon} dimensionString="32" iconString={item.icon || ''} />
          <span>{item.name}</span>
        </a>
      ))}
    </ScrollableRow>
  );
};
